<div class="substation-list">
  <lib-dynamic-cards
    [emcOptions]="cardEmc"
    [filter]="$any(cardsFilter)"
    [entityType]="entityType">
  </lib-dynamic-cards>

  <div class="filter">
    <div class="filter-bar">
      <div class="filter-left">
        <lib-emc-search-component
          [entityType]="entityType"
          (searchOutput)="onSearchOutput($event)">
        </lib-emc-search-component>

        <button class="dropdown-button" (click)="openFilterWindow()">
          <span>{{'COMMON.ADD_FILTER.PLURAL' | translate}}</span>
        </button>
      </div>

      <div class="filter-right">
        <div class="download-btn-wrapper" *ngIf="permissionsService.isPoleDownloadAllowed">
          <button (click)="download()">{{'COMMON.DOWNLOAD' | translate}}</button>
        </div>
        <div class="download-btn-wrapper" *ngIf="permissionsService.isPoleCreateEditAllowed">
          <button [routerLink]="'/upload/3/' + utilityId">{{'COMMON.UPLOAD_XLSX' | translate}}</button>
        </div>
       
      </div>
    </div>

    <div class="applied-filters" *ngIf="checklistItems.length > 0">
      <lib-filter-checklist [filters]="checklistItems" [useApply]="true"
        (resetFilterEmitter)="resetFilter()"
        (removeFilterEmitter)="removeFilter($event)"
        (applyFilterEmitter)="applyFilter()"></lib-filter-checklist>
    </div>
  </div>

  <div class="table-wrapper">
    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th *ngFor="let col of visibleColumns">{{ col.label }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of tableListPage.rows" (click)="onRowClick(row.guid)">
            <ng-container *ngFor="let col of visibleColumns">
              <td [ngSwitch]="row.data[col.index]?.valueType">
                <span *ngSwitchCase="'String'">{{ row.data[col.index]?.stringValue || '/' }}</span>
                <span *ngSwitchCase="'Int'">{{ row.data[col.index]?.intValue ?? '/' }}</span>
                <span *ngSwitchCase="'Date'">{{ (row.data[col.index]?.dateTimeValue | date:'dd/MM/yyyy') || '/' }}</span>
                <span *ngSwitchCase="'Bool'">{{ row.data[col.index]?.boolValue !== undefined ? (row.data[col.index]?.boolValue ? 'Yes' : 'No') : '/' }}</span>
                <span *ngSwitchDefault>/</span>
              </td>
            </ng-container>
            <td>...</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <lib-asset-list-pagination *ngIf="count > 0"
        [pageFromList]="currentPage"
        [itemsPerPage]="pageSize"
        [totalItems]="count"
        (pageChanged)="pageChange($event)">
      </lib-asset-list-pagination>
    </div>
  </div>

  <app-pole-filter-window
    *ngIf="isFilterWindowOpened"
    [filter]="filter"
    [filterOptions]="filterEmc"
    [poleTypes]="poleTypes"
    (close)="closeFilterWindow()"
    (addFilter)="onAddFilter()">
  </app-pole-filter-window>
</div>
